import script from "./MemberView.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberView.vue?vue&type=script&setup=true&lang=js"

import "./MemberView.vue?vue&type=style&index=0&id=77b55f03&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77b55f03"]])

export default __exports__